export default "__VITE_ASSET__BzESNYlY__"